module.exports = __webpack_public_path__ + "static/media/12.3a7e08d6.png";